export const API = {
  LOGOUT: {
    path: '/auth/logout',
    method: 'POST',
  },
  GET_CURRENT_USER: {
    path: '/auth/profile',
    method: 'GET',
  },
  GET_SESSION_TIMELINE: {
    path: '/timeline-items/session/:id',
    method: 'GET',
  },
  GET_CHAT_SESSIONS: {
    path: '/chat-sessions',
    method: 'POST',
  },

};

export const PRODUCTS = {
  MENUTIGER: 'MENUTIGER',
  QRTIGER: 'QRTIGER',
};

export const ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};
